import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M6.061 5.22a.75.75 0 0 1 1.061 0l3.72 3.72 3.72-3.72a.75.75 0 1 1 1.06 1.06L11.902 10l3.72 3.72a.75.75 0 1 1-1.06 1.06l-3.72-3.72-3.72 3.72a.75.75 0 0 1-1.06-1.06L9.781 10l-3.72-3.72a.75.75 0 0 1 0-1.06Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgComponent
